import Alert from '@components/Alert'
import Radio from '@components/Radio'
import ViewMaterial from '@components/ViewMaterial'
import WithUserTime, { WithUserTimeProps } from '@hocs/WithUserTime'
import { IschConfig, setParams } from '@layouts/LearningPath/LearningPathRedirection'
import { MaterialList, Media } from '@interfaces/MyLesson'
import first from 'lodash/first'
import groupBy from 'lodash/groupBy'
import toPairs from 'lodash/toPairs'
import Router from 'next/router'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import GroupMedia from './GroupMedia'
import { MaterialProp } from './interface'
import {
  ButtonContainer,
  FileContainer,
  Info,
  Label,
  MediaCol,
  RadioContainer,
  StyledButton,
  StyledCol,
  // P,
  // StyledPCol,
  // StyledLink,
  NoPaddingCol,
} from './style'
import { getIcon } from './utils'
import useTimeFormat from '@hooks/useTimeFormat'
import { DATE_FORMAT } from '@utils/constants'

const Materials: React.FC<MaterialProp & MaterialList & WithUserTimeProps> = ({
  // GroupName,
  Materials,
  LastMaterials,
  MaterialOptions,
  Medias = [],
  groupMaterials = [],
  note,
  studentId,
  startDate,
  toUserDate,
  studentProfile,
  ProgramId,
  isFlex,
  isBoD1,
  profile,
  activeMaterial,
  refetchData,
  SessionInfoList,
}) => {
  const [time, setTime] = React.useState('')
  const [materials, setMaterials] = React.useState(Materials)
  const [lastMaterials, setLastMaterials] = React.useState(LastMaterials)
  const [medias, setMedias] = React.useState([] as Array<Media>)
  const { convertToUserTimeFormats } = useTimeFormat()

  React.useEffect(() => {
    if (groupMaterials.length) {
      const groupMaterial = first(groupMaterials)
      setTime(groupMaterial!.StartTime)
      setMaterials(groupMaterial!.MaterialList)
      setLastMaterials(groupMaterial!.LastMaterialList)
      // setMedias(groupMaterial!.MaterialList.Medias)
    } else {
      setMaterials(Materials)
      setLastMaterials(LastMaterials)
      setMedias(Medias)
    }
  }, [])

  React.useEffect(() => {
    setMaterials(Materials)
    setLastMaterials(LastMaterials)
    setMedias(Medias)
  }, [Materials, LastMaterials, Medias])

  const miProfile = studentProfile?.MIComment
  const programs = studentProfile?.ProgramStudentWrappers ?? []
  const program = programs.find((program) => program.ProgramStudentInfo.ProgramId === ProgramId)
  const miProgram = program?.ProgramStudentInfo?.MIComment
  return (
    <>
      {groupMaterials.length > 0 && (
        <RadioContainer>
          <Radio.Group
            value={time}
            onChange={(e: any) => {
              const time = e.target.value
              const groupMaterial = groupMaterials.find((gm) => gm.StartTime === time)
              setTime(time)
              setMaterials(groupMaterial!.MaterialList)
              setLastMaterials(groupMaterial!.LastMaterialList)
              // setMedias(groupMaterial!.MaterialList.Medias)
            }}
            name="lesson"
          >
            {groupMaterials.map((gm) => (
              <Radio.Button key={gm.StartTime} id={`lesson-${gm.StartTime}`} value={gm.StartTime}>
                {convertToUserTimeFormats(
                  [
                    toUserDate(gm.StartTime, 'YYYY-MM-DD HH:mm:ss', DATE_FORMAT.HM),
                    toUserDate(gm.EndTime, 'YYYY-MM-DD HH:mm:ss', DATE_FORMAT.HM),
                  ],
                  [DATE_FORMAT.HM, DATE_FORMAT.HM]
                )?.join(' - ')}
              </Radio.Button>
            ))}
          </Radio.Group>
        </RadioContainer>
      )}

      {note && (
        <Alert alertType="error" dismissable={false}>
          <span>{note}</span>
        </Alert>
      )}
      {miProfile && (
        <Alert alertType="error" dismissable={false}>
          <span>{miProfile}</span>
        </Alert>
      )}
      {miProgram && (
        <Alert alertType="error" dismissable={false}>
          <span>{miProgram}</span>
        </Alert>
      )}
      <Row>
        <NoPaddingCol xs={12} md={8}>
          <ViewMaterial
            PrevMaterials={lastMaterials}
            Materials={materials}
            MaterialOptions={MaterialOptions.filter(({ IsTest, Name }) => !IsTest && !/MyBerlitz.*Tutor/.test(Name))}
            isFlex={isFlex}
            isBoD1={isBoD1}
            SessionInfoList={SessionInfoList}
            activeMaterial={activeMaterial}
            refetch={refetchData}
          />
        </NoPaddingCol>
        <NoPaddingCol xs={12} md={4}>
          <ButtonContainer>
            <StyledButton
              onClick={() => {
                const schConfig: IschConfig = {
                  id: studentId,
                  sd: startDate,
                  back: '/instructors/scheduling/my-lessons',
                }
                setParams(profile.SFId, schConfig)
                Router.push(`/instructors/learning-path/`)
              }}
            >
              <FormattedMessage id="View Learning Path" />
            </StyledButton>
          </ButtonContainer>
        </NoPaddingCol>
      </Row>

      {toPairs(groupBy(medias, 'Owner')).length <= 1 ? (
        <>
          {medias.length > 1 && (
            <Row>
              <MediaCol xs={12} md={2}>
                <Label>
                  <FormattedMessage id="Uploaded Media" />:
                </Label>
              </MediaCol>
              <Col xs={12} md={6}>
                <Row>
                  {medias.map((media) => {
                    const { Icon } = getIcon(media.Type)

                    return (
                      <StyledCol key={media.Name} xs={12} md={6}>
                        <FileContainer>
                          <Icon size="sm" />
                          <Info>{media.Name}</Info>
                        </FileContainer>
                      </StyledCol>
                    )
                  })}
                </Row>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <GroupMedia medias={medias} />
      )}
    </>
  )
}

export default WithUserTime(Materials)
